export default {
    Up: (position, distance) => ({ ...position, y: position.y + distance }),
    Down: (position, distance) => ({ ...position, y: position.y - distance }),
    Right: (position, distance) => ({ ...position, x: position.x + distance }),
    Left: (position, distance) => ({ ...position, x: position.x - distance }),
};
